import React, { Fragment } from 'react'
import styled from 'styled-components'
import Button from '@app.components/Button'
import Modal, {
  createOpenModal,
  IFModalProps,
} from '@app.components/Modal/Modal'
import CloseOutlined from 'svgIcons/CloseOutlined'

interface AlertModalProps extends IFModalProps {
  buttonText?: string
  message?: string
  onConfirm?: (...arg: any) => void | Promise<void>
}

const AlertModal: React.FC<AlertModalProps> = ({
  buttonText = '확인',
  message,
  onConfirm,
  onClose,
  ...props
}) => {
  const handleClose = () => {
    onClose && onClose()
  }

  const handleConfirm = async () => {
    onConfirm && (await onConfirm())
    handleClose()
  }

  const renderAlertMessage = () => {
    return (
      <>
        {message?.split('\n').map((line, index) => (
          <Fragment key={index}>
            {line.trim()}
            <br />
          </Fragment>
        ))}
      </>
    )
  }

  return (
    <Modal onClose={onClose} {...props}>
      <StyledWrapper>
        <div className="close-btn" onClick={onClose}>
          <CloseOutlined />
        </div>
        <div className="confirm-message">{renderAlertMessage()}</div>

        <Button
          variant="contained"
          className="modal-button"
          onClick={handleConfirm}
        >
          {buttonText}
        </Button>
      </StyledWrapper>
    </Modal>
  )
}

export default AlertModal

const openAlertModal = createOpenModal(AlertModal)
export { openAlertModal }

const StyledWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 101;
  background-color: #ffffff;

  border-radius: 20px;
  padding: 50px 30px;
  min-height: 215px;
  min-width: 360px;
  width: fit-content;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  text-align: center;

  .close-btn {
    cursor: pointer;
    z-index: 100;
    position: absolute;
    top: 30px;
    color: #999999;
    right: 30px;
  }
  .confirm-message {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 18px;
  }
  .modal-button {
    color: #ffffff;
    padding: 12px 30px;
    border-radius: 5px;
    & > span {
      font-size: 16px;
      font-weight: 600;
    }
  }
`
